import React, { createContext, useCallback, useEffect, useState } from 'react';
import { useHttpContext } from '@/common/hooks/HttpContext';
import { toasts } from '@/common/toasts';
import { resultIsError } from '@/services/HttpService';
import { AssessmentOutcome } from '../Scan/Outcomes/types/types';

interface IAdminOutcomesContext {
    outcomes?: AssessmentOutcome[];
    organizationId?: number;
    refresh: () => Promise<void>;
}

export const AdminOutcomesContext = createContext<IAdminOutcomesContext>({
    outcomes: undefined,
    organizationId: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    refresh: async () => {},
});

interface AdminOutcomesProviderProps {
    organizationId: number;
    children: React.ReactNode;
}

export const AdminOutcomesProvider = (props: AdminOutcomesProviderProps) => {
    const { organizationId, children } = props;
    const { httpService } = useHttpContext();
    const { errorToast } = toasts;
    const [outcomes, setOutcomes] = useState<AssessmentOutcome[]>();

    const getOutcome = useCallback(async () => {
        if (organizationId) {
            const res = await httpService.adminGetScanRiskFactorOutcomesByOrg(organizationId);
            if (!res || resultIsError(res)) {
                errorToast(`Could not load analysis data. ${res?.message || ''}`);
                return;
            }

            setOutcomes(res);
        }
    }, [organizationId]);
    useEffect(() => {
        (async () => {
            await getOutcome();
        })();
    }, [getOutcome]);

    const ctx = { outcomes, organizationId, refresh: getOutcome };
    return <AdminOutcomesContext.Provider value={ctx}>{children}</AdminOutcomesContext.Provider>;
};
